var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('h4',[_vm._v("Input your payment email")]),_c('input',{staticClass:"mt-4",attrs:{"type":"text"},on:{"keyup":function($event){return _vm.updateValue($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }